// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2UErA","footer":"Form_footer__2DVyA"};